export const Locations = ["Metro", "Bridgewater", "Valley"]